var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFatherAtYarisi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "#9191f6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.876 12.64c2.162-3.194.636-5.688.636-5.688.355-.105 1.488.638 1.488.638-.637-2.34-4.143-4.327-4.143-4.327.389-.143 1.487.14 1.487.14C8.475.64 4.969 1.668 4.969 1.668 4.863 1.064 3.127 0 3.127 0c.178.176.25 1.135.25 1.135C3.198.815 2.63.496 2.63.496c.319.744 0 2.34 0 2.34C1.71 3.759.683 6.952.683 6.952l-.39.567c-.497.71-.314 1.827.177 2.092 1.841.996 2.02-.815 2.02-.815 1.522-.177 2.656-1.88 2.656-1.88 2.053 1.063.91 4.065.023 5.217C4.03 13.61 4.865 16 4.865 16s4.877-.202 7.011-3.36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatherAtYarisi);
export default __webpack_public_path__ + "static/media/father-at-yarisi.bdd3f3afc76622787b21e5d2e9221ae7.svg";
export { ForwardRef as ReactComponent };